import { render } from "./LeftBar.vue?vue&type=template&id=54f2e66e&scoped=true"
import script from "./LeftBar.vue?vue&type=script&lang=js"
export * from "./LeftBar.vue?vue&type=script&lang=js"

import "./LeftBar.vue?vue&type=style&index=0&id=54f2e66e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f2e66e"]])

export default __exports__